import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { BoostCampaignEntity } from "../models/RewardsBoostCampaignEntities";

export interface BoostCampaignState {
    boostCampaign: BoostCampaignEntity | null;
}

const createInitialState = (): BoostCampaignState => ({
    boostCampaign: null,
});

@singleton()
@StoreConfig({ name: "RewardsBoostCampaignStore" })
class RewardsBoostCampaignStore extends BaseStore<BoostCampaignState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsBoostCampaignStore;
